export default {
      id: "badge-media-count-usage",
      viewBox: "0 0 13 13",
      url: __webpack_public_path__ + "img/icons.c2f64a3b.svg#badge-media-count",
      toString: function () {
        return this.url;
      }
    }